import React from "react";

import { AnalyticsTool } from "@smart/bridge-types-basic";
import { TextFieldInput } from "@smart/itops-sb-design-system-dom";

const availableTypes = ["googleAnalytics"] as const;
const labels: Record<(typeof availableTypes)[number], string> = {
  googleAnalytics: "Google Analytics measurement ID",
};
const defaultConfig = availableTypes.map((type) => ({ type, trackingId: "" }));

type AnalyticsConfigProps = {
  config: AnalyticsTool[] | undefined;
  setConfig: (
    set: (config: AnalyticsTool[] | undefined) => AnalyticsTool[],
  ) => void;
};

export const AnalyticsConfig = ({ config, setConfig }: AnalyticsConfigProps) =>
  (config?.length ? config : defaultConfig).map(({ type, trackingId }) => (
    <React.Fragment key={type}>
      <TextFieldInput
        label={labels[type]}
        value={trackingId}
        message="Your unique Google Analytics 4 ID (e.g., G-XXXXXXX)."
        dataTestId="analytics-config"
        onChange={(event) =>
          setConfig((existing) => [
            ...(existing || []).filter(
              ({ type: existingType }) => existingType !== type,
            ),
            { type, trackingId: event.target.value },
          ])
        }
      />
    </React.Fragment>
  ));
